// extracted by css-extract-rspack-plugin
export default {"fullWidth":"fullWidth-9JQeo","pageTextContainer":"pageTextContainer-9_7pi","pageNumberInputWrapper":"pageNumberInputWrapper-Xyg9n","pageNumberInput":"pageNumberInput-34RAh"};